<div class="div">
    <app-body></app-body>
    <app-body2></app-body2>
    <app-body3></app-body3>
    <app-body6></app-body6>
    <app-body4></app-body4>
    <app-body5></app-body5>
    <app-body7></app-body7>
</div>
